import Vue from "vue";
import App from "./App.vue";
import router from "./router";
// import vuetify from "./plugins/vuetify";
import Vuetify from "vuetify/lib";
import store from "./store";
// import colors from "vuetify/lib/util/colors";
import moment from "moment";
import { VueMaskDirective } from 'v-mask'
Vue.directive('mask', VueMaskDirective);

Vue.config.productionTip = false;
Vue.config.silent = true;
Vue.prototype.moment = moment;

const opts = {
  theme: {
    options: { customProperties: true }
  }
};

new Vue({
  router,
  store,
  vuetify: new Vuetify(opts),
  render: h => h(App)
}).$mount("#app");
console.warn = () => { };
if ('serviceWorker' in navigator && process.env.NODE_ENV === 'production') {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/service-worker.js').then(
      function (registration) {
        console.log('Service Worker registration successful with scope: ', registration.scope);
      },
      function (err) {
        console.log('Service Worker registration failed: ', err);
      }
    );
  });
}
